import { Comparator, ComparatorItem } from 'src/common/types/Comparator.ts';
import { compareAsNumbers } from 'src/sensors/list/comparAsNumbers.ts';

const parseRange = (value: string): [string, string] => {
    const [a, b] = value.split('...');
    return [a, b];
};

export const initComparatorForRange = (): Comparator => (
    a: ComparatorItem,
    b: ComparatorItem,
) => {
    try {
        const [parsedA, parsedA1] = parseRange(a.value);

        const [parsedB, parsedB1] = parseRange(b.value);

        if (parsedA === undefined || parsedB === undefined || parsedA1 === undefined || parsedB1 === undefined) {
            return compareAsNumbers(a.value, b.value);
        }

        if (parsedA === parsedB) {
            return compareAsNumbers(parsedA1, parsedB1);
        }

        return compareAsNumbers(parsedA, parsedB);
    } catch {
        return 0;
    }
};
